import React from "react";

const DarkThemeIcon = (props) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="35"
            height="35"
            viewBox="0 0 35 35"
        >
            <path
                d="M17.5 0A17.5 17.5 0 1035 17.5 17.52 17.52 0 0017.5 0zm0 31.483h-.051V3.52h.051a13.983 13.983 0 010 27.966z"
                transform="translate(-.001)"
            ></path>
        </svg>
    );
}

export default DarkThemeIcon;